import axios from 'axios';

const WIZ_ME_BFF_URL = process.env.REACT_APP_WIZ_ME_BFF_URL;
const IES_CLIENT_ID = process.env.REACT_APP_IES_OAUTH2_CLIENT_ID;

/**
 * Calls the Wizme BFF SSO endpoint with the IES authorization code.
 * Mirrors the mobile (wiztab) implementation from PR #16 / ARTFRAN-11130.
 *
 * @param {string} code - The IES authorization code from the callback URL.
 * @param {string} redirectUri - The same redirect_uri used to initiate the IES auth flow.
 * @returns {Promise<string|null>} The student's Wizme ID (platformId), or null on failure.
 */
export async function getWizmeIdFromIESCode(code, redirectUri) {
    if (!WIZ_ME_BFF_URL || !IES_CLIENT_ID) {
        console.warn('[WizmeBFF] REACT_APP_WIZ_ME_BFF_URL or REACT_APP_IES_OAUTH2_CLIENT_ID not set.');
        return null;
    }

    try {
        const response = await axios.post(
            `${WIZ_ME_BFF_URL}/iam/api/v1/signin/sso/ies`,
            {
                clientId: IES_CLIENT_ID,
                code: code,
                redirectUri: redirectUri,
            }
        );

        const payload = (response.data && response.data.data) || response.data;
        const wizmeId = (payload && payload.id) || null;

        if (wizmeId) {
            console.log('[WizmeBFF] Wizme ID obtained:', wizmeId);
        } else {
            console.warn('[WizmeBFF] Response did not contain a Wizme ID.', response.data);
        }

        return wizmeId;
    } catch (error) {
        console.warn('[WizmeBFF] Could not retrieve Wizme user:', (error && error.response && error.response.data) || error.message);
        return null;
    }
}
